import { Mark } from '@tiptap/vue-3';

/**
 * Basic block and nestable span node extension.
 */
export const SpanExtension = Mark.create({
  name: 'span',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        // TextStyleExtension handles spans with inline styles; deferring here
        // prevents both marks from matching the same span and producing nested
        // <span style="..."><span style="..."> output on serialization.
        getAttrs: (node) => ((node as Element).hasAttribute('style') ? false : {}),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },
});
